module.exports = __webpack_public_path__ + "static/media/MetuoPersonalUse-Black.4bf05140.otf";